import { combineReducers } from 'redux-immutable'

import operationLog from './operationLog/reducer'

export default combineReducers({
  operationLog,
})
